import reducer from './reducer';
import actions from './actions';

export default {
	reducer,
	actions,
};
